import { h as o } from "vue";
const m = (n, r) => {
  const a = "http://www.w3.org/2000/svg", t = new DOMParser().parseFromString(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
  <path d="M16 29.58a.8.8 0 01-.39-.1 44.18 44.18 0 01-7.34-5.35 28.42 28.42 0 01-5.09-5.88 14 14 0 01-2.36-7.44 8.4 8.4 0 018.39-8.39 8.07 8.07 0 014.68 1.65A8.81 8.81 0 0116 6.24a8.81 8.81 0 012.11-2.17 8.07 8.07 0 014.68-1.65 8.4 8.4 0 018.39 8.39 14.06 14.06 0 01-2.37 7.45 28.41 28.41 0 01-5.08 5.88 44.18 44.18 0 01-7.34 5.35.8.8 0 01-.39.1zM9.21 4a6.8 6.8 0 00-6.79 6.79c0 4.86 3.75 9.27 6.9 12.12A44.37 44.37 0 0016 27.86a44.39 44.39 0 006.68-4.93c3.15-2.85 6.9-7.26 6.9-12.12A6.8 6.8 0 0022.79 4a6.94 6.94 0 00-6 4.25.8.8 0 01-1.52 0A6.94 6.94 0 009.21 4z"/>
</svg>
`, "image/svg+xml").firstChild;
  if (n.title) {
    const e = document.createElementNS(a, "title");
    e.textContent = n.title, t.appendChild(e);
  }
  const i = Array.from((t == null ? void 0 : t.attributes) ?? []).reduce((e, s) => ({
    ...e,
    [s.name]: s.value
  }));
  return o(
    "svg",
    {
      ...i,
      ...r.attrs,
      role: "img",
      innerHTML: t.innerHTML
    }
  );
};
export {
  m as default
};
//# sourceMappingURL=HeartsNewIcon.Zioj2TFF.js.map
